import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, ExternalCreditDataForm } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AddExternalCredit = function AddExternalCredit(_ref) {
  var history = _ref.history;
  return ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0421\u044A\u0437\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u044A\u043D\u0448\u0435\u043D \u043A\u0440\u0435\u0434\u0438\u0442"
  }, ___EmotionJSX(ExternalCreditDataForm, {
    onSubmit: function onSubmit() {
      return history.push('/external-credit');
    }
  }))));
};

AddExternalCredit.propTypes = {
  history: PropTypes.object
};
export default AddExternalCredit;